import "./third-party-library-to-import/tom-select@2.3.1/tom-select.complete.min.js";

document.addEventListener("turbolinks:load", () => {
  initializeObservationClipOfficials();
});

function initializeObservationClipOfficials() {
  const selectElement = document.getElementById('observation_clip_official_ids');
  
  if (selectElement && !selectElement.tomselect) {
    new TomSelect('#observation_clip_official_ids', {
      maxItems: null,
      plugins: ['remove_button'],
      create: false,
      render: {
        item: function(data, escape) {
          return '<div class="selected-official-item">' + escape(data.text) + '</div>';
        },
        option: function(data, escape) {
          return '<div class="option">' + escape(data.text) + '</div>';
        }
      }
    });
  }
}

window.initializeObservationClipOfficials = initializeObservationClipOfficials;
